import './ie11'; // IE 11
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './app/store';
import { loadInitialState } from './features/authentication/authenticationSlice';

import './scss/app.core.scss';
import './i18n';

//import * as serviceWorker from './serviceWorker';

const render = () => {
  const App = require('./app/App').default;
  ReactDOM.render(
    <React.StrictMode>
      <Suspense fallback={null}>
        <Provider store={store}>
          <App />
        </Provider>
      </Suspense>
    </React.StrictMode>,
    document.getElementById('root'),
  );
};

store.dispatch(loadInitialState(true));
render();

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./app/App', render);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
